module.exports = __webpack_public_path__ + "img/join_03.06580fff.jpg";